
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire293c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire293c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("c286w", function(module, exports) {
class $61b781b208693d9b$var$ConstDavosMenu extends HTMLUListElement {
    connectedCallback() {
        let current = this.getAttribute("current");
        if (current) {
            let currentElem = this.querySelector("." + current);
            if (currentElem) currentElem.classList.add("current");
        }
    }
}
customElements.define("const-davos-menu", $61b781b208693d9b$var$ConstDavosMenu, {
    extends: "ul"
});

});

parcelRequire("c286w");


//# sourceMappingURL=davos.d1a62d21.js.map
